import React, { FC, memo } from 'react';
import { useI18n } from '~Hooks';
import { Box } from '~Styles';
import Icon from '~ComponentsImproved/Icon';
import LicenseIcon from '~Assets/icons/license.svg';
import Heading from '~ComponentsImproved/Typography/Heading';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';

interface Props {
  /** Explains which license is missing */
  text: string;
}

/** Full-page notice used by settings scenes that require a license the device lacks */
const LicenseRequired: FC<Props> = ({ text }) => {
  const { i18n } = useI18n();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap="xs"
      justifyContent="center"
      padding="large">
      <Icon height="48px" width="48px" src={LicenseIcon} color="var(--colorBlueGray200)" />
      <Heading level={2} color="var(--colorWhite)">
        {i18n('ClaimLicense.LicenseRequired')}
      </Heading>
      <Paragraph style={{ textAlign: 'center' }} level={4} color="var(--colorBlueGray200)">
        {text}
      </Paragraph>
    </Box>
  );
};

export default memo(LicenseRequired);
